export const templateChallengesListing = String.raw`<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>Challenges — Nemonto</title>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link href="https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap" rel="stylesheet">
<style>
  :root{
    --spice:#D85A30; --spice-deep:#B23D18; --cream:#FAECE7; --peach:#F5C4B3;
    --charcoal:#2C2C2A; --herb:#1D9E75; --gold:#FAC775; --muted:#8A7A72;
    --serif:'DM Serif Display', Georgia, serif; --sans:'DM Sans', system-ui, sans-serif;
  }
  *{margin:0;padding:0;box-sizing:border-box;}
  body{background:#F1E4DE; color:var(--charcoal); font-family:var(--sans); font-size:14px; height:100vh; overflow:hidden;}
  a{color:inherit; text-decoration:none;}
  button{font-family:inherit; cursor:pointer; border:none; background:none;}
  :focus-visible{outline:2.5px solid var(--spice); outline-offset:2px; border-radius:4px;}
  ::-webkit-scrollbar{width:7px;}
  ::-webkit-scrollbar-thumb{background:rgba(44,44,42,0.14); border-radius:10px;}
  ::-webkit-scrollbar-track{background:transparent;}

  .app{display:grid; grid-template-columns:264px minmax(0,1fr) 300px; height:100vh; width:100%; max-width:none; margin:0;}

  /* ============ LEFT SIDEBAR ============ */
  .sidebar{padding:26px 18px; display:flex; flex-direction:column; height:100vh; border-right:1px solid rgba(44,44,42,0.07);}
  .brand{display:flex; align-items:center; gap:9px; font-family:var(--serif); font-size:21px; padding:0 10px 28px;}
  .nav-item{display:flex; align-items:center; gap:13px; padding:11px 12px; border-radius:14px; width:100%; font-size:15px; font-weight:500; color:#6B5F58; transition:background .15s, color .15s;}
  .nav-item:hover{background:rgba(44,44,42,0.04);}
  .nav-item.active{background:var(--spice); color:var(--cream);}
  .nav-icon{width:21px; height:21px; flex-shrink:0; display:flex; align-items:center; justify-content:center;}
  .nav-badge{margin-left:auto; background:var(--gold); color:#5A3A00; font-size:10.5px; font-weight:700; padding:2px 7px; border-radius:20px;}
  .nav-item.active .nav-badge{background:rgba(250,236,231,0.25); color:var(--cream);}
  .post-btn{margin:18px 10px 22px; background:var(--spice); color:var(--cream); padding:13px; border-radius:16px; font-size:14.5px; font-weight:700; display:flex; align-items:center; justify-content:center; gap:8px; transition:transform .15s, box-shadow .15s;}
  .post-btn:hover{transform:translateY(-1px); box-shadow:0 10px 22px rgba(216,90,48,0.3);}
  .sidebar-spacer{flex:1;}
  .profile-mini{display:flex; align-items:center; gap:10px; padding:9px 10px; border-radius:14px;}
  .pm-avatar{width:38px; height:38px; border-radius:50%; background:#9FE1CB; flex-shrink:0;}
  .pm-name{font-size:13.5px; font-weight:600;}
  .pm-handle{font-size:11.5px; color:#9A8C84;}
  .pm-more{margin-left:auto; color:#9A8C84;}

  /* ============ CENTER ============ */
  .main-col{height:100vh; overflow-y:auto; border-right:1px solid rgba(44,44,42,0.07);}

  .page-header{
    position:sticky; top:0; z-index:5; background:rgba(241,228,222,0.94); backdrop-filter:blur(8px);
    padding:22px 28px 0; border-bottom:1px solid rgba(44,44,42,0.06);
  }
  .ph-title{font-family:var(--serif); font-size:24px; margin-bottom:4px;}
  .ph-sub{font-size:13px; color:#9A8C84; margin-bottom:16px;}

  .status-tabs{display:flex; gap:24px; margin-bottom:0;}
  .status-tab{padding-bottom:13px; font-size:13.5px; font-weight:600; color:#9A8C84; position:relative; display:flex; align-items:center; gap:7px;}
  .status-tab.active{color:var(--spice-deep);}
  .status-tab.active::after{content:''; position:absolute; bottom:0; left:0; right:0; height:2.5px; background:var(--spice); border-radius:2px;}
  .st-count{background:rgba(44,44,42,0.06); font-size:10.5px; font-weight:700; padding:1px 7px; border-radius:20px; color:#6B5F58;}
  .status-tab.active .st-count{background:rgba(216,90,48,0.14); color:var(--spice-deep);}
  .st-dot{width:6px; height:6px; border-radius:50%; flex-shrink:0;}

  .body-wrap{padding:22px 28px 60px;}

  /* featured hero */
  .featured-card{
    background:var(--charcoal); border-radius:24px; padding:28px; position:relative; overflow:hidden; margin-bottom:30px;
  }
  .featured-card::before{content:''; position:absolute; top:-100px; left:-80px; width:300px; height:300px; background:radial-gradient(circle, rgba(216,90,48,0.35), transparent 70%);}
  .featured-tag{display:inline-flex; align-items:center; gap:7px; background:rgba(250,199,117,0.18); color:var(--gold); font-size:11px; font-weight:700; letter-spacing:0.04em; text-transform:uppercase; padding:6px 13px; border-radius:20px; margin-bottom:18px; position:relative;}
  .featured-grid{display:grid; grid-template-columns:1fr 1fr; gap:24px; align-items:center; position:relative;}
  .featured-host{display:flex; align-items:center; gap:9px; margin-bottom:14px;}
  .fh-avatar{width:32px; height:32px; border-radius:50%; flex-shrink:0;}
  .fh-name{font-size:12.5px; font-weight:600; color:var(--cream);}
  .fh-tag{font-size:10.5px; color:rgba(250,236,231,0.5);}
  .featured-title{font-family:var(--serif); font-size:28px; color:var(--cream); line-height:1.2; margin-bottom:14px;}
  .featured-chips{display:flex; gap:7px; flex-wrap:wrap; margin-bottom:18px;}
  .featured-chips span{background:rgba(250,236,231,0.1); color:var(--cream); font-size:11.5px; padding:5px 11px; border-radius:20px;}
  .featured-cta{display:inline-flex; align-items:center; gap:8px; background:var(--gold); color:#5A3A00; font-size:13.5px; font-weight:700; padding:11px 22px; border-radius:30px;}
  .featured-stats{display:flex; gap:12px;}
  .fs-stat{flex:1; background:rgba(250,236,231,0.07); border-radius:14px; padding:16px; text-align:center;}
  .fs-stat b{display:block; font-size:24px; color:var(--gold); font-family:var(--serif);}
  .fs-stat span{font-size:10.5px; color:rgba(250,236,231,0.55);}

  /* grid */
  .section-row-label{font-size:13px; font-weight:700; color:#6B5F58; margin-bottom:14px; text-transform:uppercase; letter-spacing:0.04em;}
  .challenge-grid{display:grid; grid-template-columns:1fr 1fr; gap:16px; margin-bottom:32px;}
  .ch-card{background:#fff; border-radius:20px; overflow:hidden; border:1px solid rgba(44,44,42,0.06); transition:transform .18s, box-shadow .18s; cursor:pointer;}
  .ch-card:hover{transform:translateY(-3px); box-shadow:0 18px 36px -14px rgba(44,28,18,0.18);}

  .ch-thumb{height:130px; position:relative; display:flex; align-items:center; justify-content:center;}
  .ch-status-pill{position:absolute; top:11px; left:11px; font-size:10px; font-weight:700; padding:4px 10px; border-radius:20px; display:flex; align-items:center; gap:5px;}
  .ch-status-pill.live{background:var(--spice); color:#fff;}
  .ch-status-pill.ending{background:var(--gold); color:#5A3A00;}
  .ch-status-pill.winner{background:rgba(44,44,42,0.85); color:var(--gold);}
  .ch-status-pill .pulse-dot{width:5px; height:5px; border-radius:50%; background:#fff; animation:pulse 1.8s infinite;}
  @keyframes pulse{0%,100%{opacity:1;}50%{opacity:0.3;}}
  .ch-time-pill{position:absolute; bottom:11px; right:11px; background:rgba(0,0,0,0.45); color:#fff; font-size:10.5px; font-weight:600; padding:4px 9px; border-radius:20px;}

  .ch-body{padding:14px 16px;}
  .ch-host-row{display:flex; align-items:center; gap:7px; margin-bottom:8px;}
  .ch-host-avatar{width:22px; height:22px; border-radius:50%; flex-shrink:0;}
  .ch-host-name{font-size:11.5px; color:#9A8C84; font-weight:600;}
  .ch-title{font-family:var(--serif); font-size:16px; line-height:1.3; margin-bottom:9px;}
  .ch-ingredients{display:flex; gap:5px; flex-wrap:wrap; margin-bottom:11px;}
  .ch-ingredients span{background:var(--cream); color:var(--spice-deep); font-size:10px; font-weight:600; padding:3px 8px; border-radius:20px;}
  .ch-foot{display:flex; align-items:center; justify-content:space-between; padding-top:10px; border-top:1px solid rgba(44,44,42,0.06);}
  .ch-entries{font-size:11.5px; color:#9A8C84;}
  .ch-entries b{color:var(--spice-deep);}
  .ch-enter-btn{font-size:11.5px; font-weight:700; color:var(--spice-deep); padding:6px 13px; border-radius:20px; border:1px solid rgba(216,90,48,0.3);}

  .ch-winner-strip{
    background:rgba(250,199,117,0.12); border-top:1px solid rgba(250,199,117,0.35); padding:10px 16px;
    display:flex; align-items:center; gap:9px; font-size:11.5px; color:#8A5A00;
  }
  .winner-avatar-sm{width:22px; height:22px; border-radius:50%; flex-shrink:0; border:1.5px solid var(--gold);}

  /* ============ RIGHT RAIL ============ */
  .right-rail{height:100vh; overflow-y:auto; padding:24px 20px 40px;}
  .rail-block{margin-bottom:28px;}
  .rail-head{margin-bottom:14px;}
  .rail-head h3{font-size:13px; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:#6B5F58;}

  .host-cta-card{background:var(--charcoal); border-radius:18px; padding:20px; position:relative; overflow:hidden;}
  .host-cta-card::before{content:''; position:absolute; top:-50px; right:-40px; width:130px; height:130px; background:radial-gradient(circle, rgba(250,199,117,0.3), transparent 70%);}
  .host-cta-card p.label{font-size:10.5px; letter-spacing:0.06em; text-transform:uppercase; color:var(--gold); margin-bottom:8px; position:relative;}
  .host-cta-card p.title{font-family:var(--serif); font-size:17px; color:var(--cream); line-height:1.3; margin-bottom:10px; position:relative;}
  .host-cta-card p.sub{font-size:12px; color:rgba(250,236,231,0.6); line-height:1.5; margin-bottom:16px; position:relative;}
  .host-cta-btn{display:block; text-align:center; background:var(--gold); color:#5A3A00; font-size:12.5px; font-weight:700; padding:10px 0; border-radius:14px; position:relative;}

  .leaderboard-card{background:#fff; border-radius:16px; padding:6px; border:1px solid rgba(44,44,42,0.06);}
  .lb-row{display:flex; align-items:center; gap:10px; padding:10px; border-radius:12px;}
  .lb-row:hover{background:#F8EFEB;}
  .lb-rank{width:22px; font-family:var(--serif); font-size:14px; color:#9A8C84; text-align:center; flex-shrink:0;}
  .lb-rank.gold{color:var(--gold); font-size:17px;}
  .lb-avatar{width:32px; height:32px; border-radius:50%; flex-shrink:0;}
  .lb-name{font-size:12.5px; font-weight:600; display:flex; align-items:center; gap:4px;}
  .lb-meta{font-size:10.5px; color:#9A8C84;}
  .lb-wins{margin-left:auto; font-family:var(--serif); font-size:14px; color:var(--spice-deep);}

  .cuisine-filter-cloud{display:flex; flex-wrap:wrap; gap:6px;}
  .cf-pill{background:#fff; border:1px solid rgba(44,44,42,0.08); color:#6B5F58; font-size:11.5px; padding:6px 12px; border-radius:20px;}
  .cf-pill.active{background:var(--spice); border-color:var(--spice); color:#fff;}

  @media (max-width:1180px){
    .app{grid-template-columns:84px minmax(0,1fr) 300px;}
    .brand span.brand-text, .nav-item span.nav-label, .post-btn span.btn-label, .pm-name, .pm-handle{display:none;}
    .nav-item{justify-content:center;} .nav-badge{display:none;} .post-btn{padding:13px;} .profile-mini{justify-content:center;}
  }
  @media (max-width:980px){
    .app{grid-template-columns:84px minmax(0,1fr);}
    .right-rail{display:none;}
    .challenge-grid{grid-template-columns:1fr;}
    .featured-grid{grid-template-columns:1fr;}
  }
</style>
</head>
<body>

<div class="app">

  <!-- ================= LEFT SIDEBAR ================= -->
  <aside class="sidebar">
    <div class="brand">
      <img src="../image/nemonto-logo.png" alt="Nemonto" style="height:32px; width:auto; display:block;" />
    </div>
    <nav>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 11l8-7 8 7M6 10v9a1 1 0 001 1h4v-6h2v6h4a1 1 0 001-1v-9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Home</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.8"/><path d="M20 20l-3.5-3.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></span>
        <span class="nav-label">Explore</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 4h16v12H7l-3 3V4z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Made it</span>
      </a>
      <a class="nav-item active" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 21V5a1 1 0 011-1h14a1 1 0 011 1v16l-8-4-8 4z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Challenges</span>
        <span class="nav-badge">3 live</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M20.8 4.6c-1.5-1.5-4-1.5-5.6.1L12 7.9 8.8 4.7c-1.6-1.6-4.1-1.6-5.6-.1-1.5 1.5-1.5 4 .1 5.6L12 19l8.7-8.8c1.6-1.6 1.6-4.1.1-5.6z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Saved</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M21 11.5a8.4 8.4 0 01-1.2 4.4L21 20l-4.3-1.2a8.5 8.5 0 11-1.8-15.6 8.5 8.5 0 016.1 7.3z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Messages</span>
        <span class="nav-badge">2</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="9" cy="8" r="3.4" stroke="currentColor" stroke-width="1.6"/><path d="M3 19c0-3 2.5-5 6-5s6 2 6 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></span>
        <span class="nav-label">Profile</span>
      </a>
    </nav>
    <div class="post-btn">
      <svg width="17" height="17" viewBox="0 0 20 20" fill="none"><path d="M10 4v12M4 10h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
      <span class="btn-label">New recipe</span>
    </div>
    <div class="sidebar-spacer"></div>
    <div class="profile-mini">
      <div class="pm-avatar"></div>
      <div><div class="pm-name">Priya Rajan</div><div class="pm-handle">@priyacooks</div></div>
      <span class="pm-more">⋯</span>
    </div>
  </aside>

  <!-- ================= CENTER ================= -->
  <main class="main-col">

    <div class="page-header">
      <p class="ph-title">Challenges</p>
      <p class="ph-sub">Real creators set the rules. Real creators pick the winner.</p>

      <div class="status-tabs" id="statusTabs">
        <div class="status-tab active" data-status="all">All <span class="st-count">14</span></div>
        <div class="status-tab" data-status="live"><span class="st-dot" style="background:var(--spice);"></span>Live <span class="st-count">3</span></div>
        <div class="status-tab" data-status="ending"><span class="st-dot" style="background:var(--gold);"></span>Ending soon <span class="st-count">2</span></div>
        <div class="status-tab" data-status="winner"><span class="st-dot" style="background:#9A8C84;"></span>Winner declared <span class="st-count">9</span></div>
      </div>
    </div>

    <div class="body-wrap">

      <!-- FEATURED -->
      <div class="featured-card" id="featuredCard">
        <span class="featured-tag">⭐ Challenge of the week</span>
        <div class="featured-grid">
          <div>
            <div class="featured-host">
              <div class="fh-avatar" style="background:#F0997B;"></div>
              <div><div class="fh-name">Maria K. 🏅</div><div class="fh-tag">Founding Creator #002</div></div>
            </div>
            <p class="featured-title">Pasta with 3 ingredients only</p>
            <div class="featured-chips">
              <span>🍝 Pasta</span><span>🥚 Eggs</span><span>🧀 Pecorino</span><span>⏱ 30 min max</span>
            </div>
            <a href="#" class="featured-cta">Enter this challenge →</a>
          </div>
          <div class="featured-stats">
            <div class="fs-stat"><b>84</b><span>entries</span></div>
            <div class="fs-stat"><b>47h</b><span>remaining</span></div>
            <div class="fs-stat"><b>8.2k</b><span>notified</span></div>
          </div>
        </div>
      </div>

      <!-- LIVE -->
      <p class="section-row-label">🔴 Live now</p>
      <div class="challenge-grid" id="grid-live">

        <div class="ch-card" data-status="live">
          <div class="ch-thumb" style="background:linear-gradient(150deg,#6FCBA4,#0D6B4E);">
            <span class="ch-status-pill live"><span class="pulse-dot"></span>LIVE</span>
            <span class="ch-time-pill">6h left</span>
            <svg width="40" height="40" viewBox="0 0 100 100"><circle cx="38" cy="44" r="10" fill="#fff" opacity="0.9"/><circle cx="58" cy="40" r="8" fill="#fff" opacity="0.7"/></svg>
          </div>
          <div class="ch-body">
            <div class="ch-host-row"><div class="ch-host-avatar" style="background:#9FE1CB;"></div><span class="ch-host-name">Priya R. 🏅</span></div>
            <p class="ch-title">One-pan South Asian breakfast</p>
            <div class="ch-ingredients"><span>🥚 Eggs</span><span>🧅 Onion</span><span>🍞 Bread</span></div>
            <div class="ch-foot">
              <span class="ch-entries"><b>31</b> entries</span>
              <span class="ch-enter-btn">Enter now</span>
            </div>
          </div>
        </div>

        <div class="ch-card" data-status="live">
          <div class="ch-thumb" style="background:linear-gradient(150deg,#FCD58E,#BA7517);">
            <span class="ch-status-pill live"><span class="pulse-dot"></span>LIVE</span>
            <span class="ch-time-pill">2d left</span>
            <svg width="40" height="40" viewBox="0 0 100 100"><path d="M24 48 Q24 70 50 70 Q76 70 76 48 Z" fill="#fff" opacity="0.85"/></svg>
          </div>
          <div class="ch-body">
            <div class="ch-host-row"><div class="ch-host-avatar" style="background:#FAC775;"></div><span class="ch-host-name">Sofia M. 🏅</span></div>
            <p class="ch-title">No-knead focaccia, your way</p>
            <div class="ch-ingredients"><span>🌾 Flour</span><span>🧂 Salt</span><span>🫒 Olive oil</span></div>
            <div class="ch-foot">
              <span class="ch-entries"><b>52</b> entries</span>
              <span class="ch-enter-btn">Enter now</span>
            </div>
          </div>
        </div>

      </div>

      <!-- ENDING SOON -->
      <p class="section-row-label">⏳ Ending soon</p>
      <div class="challenge-grid" id="grid-ending">

        <div class="ch-card" data-status="ending">
          <div class="ch-thumb" style="background:linear-gradient(150deg,#E8916F,#B23D18);">
            <span class="ch-status-pill ending">⏳ ENDING SOON</span>
            <span class="ch-time-pill">47h left</span>
            <svg width="40" height="40" viewBox="0 0 100 100"><path d="M18 50 Q18 80 50 80 Q82 80 82 50 Z" fill="#fff" opacity="0.9"/></svg>
          </div>
          <div class="ch-body">
            <div class="ch-host-row"><div class="ch-host-avatar" style="background:#F0997B;"></div><span class="ch-host-name">Maria K. 🏅</span></div>
            <p class="ch-title">Pasta with 3 ingredients only</p>
            <div class="ch-ingredients"><span>🍝 Pasta</span><span>🥚 Eggs</span><span>🧀 Pecorino</span></div>
            <div class="ch-foot">
              <span class="ch-entries"><b>84</b> entries</span>
              <span class="ch-enter-btn">Enter now</span>
            </div>
          </div>
        </div>

        <div class="ch-card" data-status="ending">
          <div class="ch-thumb" style="background:linear-gradient(150deg,#9890DF,#534AB7);">
            <span class="ch-status-pill ending">⏳ ENDING SOON</span>
            <span class="ch-time-pill">9h left</span>
            <svg width="40" height="40" viewBox="0 0 100 100"><rect x="22" y="34" width="56" height="42" rx="8" fill="#fff" opacity="0.6"/></svg>
          </div>
          <div class="ch-body">
            <div class="ch-host-row"><div class="ch-host-avatar" style="background:#AFA9EC;"></div><span class="ch-host-name">James L.</span></div>
            <p class="ch-title">Weeknight curry, 20 minutes flat</p>
            <div class="ch-ingredients"><span>🍗 Chicken</span><span>🥥 Coconut milk</span><span>🌶️ Chili</span></div>
            <div class="ch-foot">
              <span class="ch-entries"><b>26</b> entries</span>
              <span class="ch-enter-btn">Enter now</span>
            </div>
          </div>
        </div>

      </div>

      <!-- WINNER DECLARED -->
      <p class="section-row-label">🏆 Winner declared</p>
      <div class="challenge-grid" id="grid-winner">

        <div class="ch-card" data-status="winner">
          <div class="ch-thumb" style="background:linear-gradient(150deg,#9890DF,#534AB7);">
            <span class="ch-status-pill winner">🏆 WINNER PICKED</span>
            <svg width="40" height="40" viewBox="0 0 100 100"><rect x="22" y="34" width="56" height="42" rx="8" fill="#fff" opacity="0.5"/></svg>
          </div>
          <div class="ch-body">
            <div class="ch-host-row"><div class="ch-host-avatar" style="background:#AFA9EC;"></div><span class="ch-host-name">James L.</span></div>
            <p class="ch-title">One-pan BBQ flatbread</p>
            <div class="ch-ingredients"><span>🫓 Flatbread</span><span>🍗 BBQ chicken</span><span>🧀 Cheese</span></div>
          </div>
          <div class="ch-winner-strip">
            <div class="winner-avatar-sm" style="background:#9FE1CB;"></div>
            Won by <b>Priya R.</b> — smoked paprika twist
          </div>
        </div>

        <div class="ch-card" data-status="winner">
          <div class="ch-thumb" style="background:linear-gradient(150deg,#FCD58E,#BA7517);">
            <span class="ch-status-pill winner">🏆 WINNER PICKED</span>
            <svg width="40" height="40" viewBox="0 0 100 100"><path d="M24 48 Q24 70 50 70 Q76 70 76 48 Z" fill="#fff" opacity="0.7"/></svg>
          </div>
          <div class="ch-body">
            <div class="ch-host-row"><div class="ch-host-avatar" style="background:#FAC775;"></div><span class="ch-host-name">Sofia M. 🏅</span></div>
            <p class="ch-title">Bake it under 30 minutes</p>
            <div class="ch-ingredients"><span>🌾 Flour</span><span>🍯 Honey</span><span>🥛 Milk</span></div>
          </div>
          <div class="ch-winner-strip">
            <div class="winner-avatar-sm" style="background:#F5C4B3;"></div>
            Won by <b>Chen W.</b> — sesame swirl bun
          </div>
        </div>

        <div class="ch-card" data-status="winner">
          <div class="ch-thumb" style="background:linear-gradient(150deg,#6FCBA4,#0D6B4E);">
            <span class="ch-status-pill winner">🏆 WINNER PICKED</span>
            <svg width="40" height="40" viewBox="0 0 100 100"><circle cx="38" cy="44" r="10" fill="#fff" opacity="0.7"/></svg>
          </div>
          <div class="ch-body">
            <div class="ch-host-row"><div class="ch-host-avatar" style="background:#9FE1CB;"></div><span class="ch-host-name">Priya R. 🏅</span></div>
            <p class="ch-title">Sunday sauce showdown</p>
            <div class="ch-ingredients"><span>🍅 Tomato</span><span>🧄 Garlic</span><span>🌿 Basil</span></div>
          </div>
          <div class="ch-winner-strip">
            <div class="winner-avatar-sm" style="background:#AFA9EC;"></div>
            Won by <b>Tom R.</b> — 6-hour Sunday ragù
          </div>
        </div>

        <div class="ch-card" data-status="winner">
          <div class="ch-thumb" style="background:linear-gradient(150deg,#E8693D,#993C1D);">
            <span class="ch-status-pill winner">🏆 WINNER PICKED</span>
            <svg width="40" height="40" viewBox="0 0 100 100"><circle cx="50" cy="50" r="22" fill="#fff" opacity="0.6"/></svg>
          </div>
          <div class="ch-body">
            <div class="ch-host-row"><div class="ch-host-avatar" style="background:#F5C4B3;"></div><span class="ch-host-name">Chen W.</span></div>
            <p class="ch-title">Breakfast on a budget</p>
            <div class="ch-ingredients"><span>🥚 Eggs</span><span>🍚 Rice</span><span>🧂 Soy sauce</span></div>
          </div>
          <div class="ch-winner-strip">
            <div class="winner-avatar-sm" style="background:#9FE1CB;"></div>
            Won by <b>Priya R.</b> — fried rice, 12 minutes
          </div>
        </div>

      </div>

    </div>
  </main>

  <!-- ================= RIGHT RAIL ================= -->
  <aside class="right-rail">

    <div class="rail-block">
      <div class="host-cta-card">
        <p class="label">For creators</p>
        <p class="title">Got a recipe worth competing for?</p>
        <p class="sub">Set the rules, set the clock, and pick the winner yourself. Your followers get notified the moment you go live.</p>
        <a href="#" class="host-cta-btn">Host a challenge</a>
      </div>
    </div>

    <div class="rail-block">
      <div class="rail-head"><h3>Top challenge winners</h3></div>
      <div class="leaderboard-card">
        <div class="lb-row">
          <span class="lb-rank gold">🥇</span>
          <div class="lb-avatar" style="background:#9FE1CB;"></div>
          <div><div class="lb-name">Priya R. <span style="font-size:11px;">🏅</span></div><div class="lb-meta">3 wins this month</div></div>
          <span class="lb-wins">3</span>
        </div>
        <div class="lb-row">
          <span class="lb-rank gold">🥈</span>
          <div class="lb-avatar" style="background:#F5C4B3;"></div>
          <div><div class="lb-name">Chen W.</div><div class="lb-meta">2 wins this month</div></div>
          <span class="lb-wins">2</span>
        </div>
        <div class="lb-row">
          <span class="lb-rank gold">🥉</span>
          <div class="lb-avatar" style="background:#AFA9EC;"></div>
          <div><div class="lb-name">Tom R.</div><div class="lb-meta">2 wins this month</div></div>
          <span class="lb-wins">2</span>
        </div>
        <div class="lb-row">
          <span class="lb-rank">4</span>
          <div class="lb-avatar" style="background:#FAC775;"></div>
          <div><div class="lb-name">Sofia M. <span style="font-size:11px;">🏅</span></div><div class="lb-meta">1 win this month</div></div>
          <span class="lb-wins">1</span>
        </div>
      </div>
    </div>

    <div class="rail-block">
      <div class="rail-head"><h3>Filter by cuisine</h3></div>
      <div class="cuisine-filter-cloud">
        <span class="cf-pill active">All</span>
        <span class="cf-pill">🍝 Italian</span>
        <span class="cf-pill">🍛 South Asian</span>
        <span class="cf-pill">🍖 BBQ</span>
        <span class="cf-pill">🥐 Bakery</span>
        <span class="cf-pill">🍜 East Asian</span>
      </div>
    </div>

  </aside>

</div>

<script>
  document.querySelectorAll('.status-tab').forEach(tab => {
    tab.addEventListener('click', () => {
      document.querySelectorAll('.status-tab').forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      const status = tab.dataset.status;

      document.getElementById('featuredCard').style.display = (status === 'all' || status === 'live' || status === 'ending') ? 'block' : 'none';

      document.querySelectorAll('.section-row-label').forEach(label => label.style.display = 'block');
      document.getElementById('grid-live').style.display = 'grid';
      document.getElementById('grid-ending').style.display = 'grid';
      document.getElementById('grid-winner').style.display = 'grid';

      const labels = document.querySelectorAll('.section-row-label');

      if(status === 'all'){
        return;
      }
      if(status === 'live'){
        labels[1].style.display = 'none';
        labels[2].style.display = 'none';
        document.getElementById('grid-ending').style.display = 'none';
        document.getElementById('grid-winner').style.display = 'none';
      }
      if(status === 'ending'){
        labels[0].style.display = 'none';
        labels[2].style.display = 'none';
        document.getElementById('grid-live').style.display = 'none';
        document.getElementById('grid-winner').style.display = 'none';
      }
      if(status === 'winner'){
        labels[0].style.display = 'none';
        labels[1].style.display = 'none';
        document.getElementById('grid-live').style.display = 'none';
        document.getElementById('grid-ending').style.display = 'none';
      }
    });
  });

  document.querySelectorAll('.cf-pill').forEach(pill => {
    pill.addEventListener('click', () => {
      document.querySelectorAll('.cf-pill').forEach(p => p.classList.remove('active'));
      pill.classList.add('active');
    });
  });
</script>

</body>
</html>

`;
